import { ControlWrapper } from "../common";
import { generateRandomID } from "../../../helpers/utilities";
import { Icon } from "../../icons";
import "./field.scss";
import classNames from "classnames";

export interface InputCommon extends React.InputHTMLAttributes<HTMLInputElement> {
    testId?: string;
    hooks?: any;
    randomId?: string;
    label?: string;
    subLabel?: string;
}

interface InputControlProps extends InputCommon {}

export const InputControl = (props: InputControlProps) => {
    return (
        <input 
            {...(props?.hooks ?? {})}
            type={props.type} 
            className={`field ${props?.className ?? ""}`}
            placeholder={props?.placeholder ?? ""}
            minLength={props?.minLength ?? 0}
            data-testid={props?.testId ?? "test-none"}
            maxLength={props?.maxLength}
            autoComplete={props?.autoComplete ?? 'off'}
            autoCorrect="off"
            id={props.randomId}
            onChange={props?.onChange}
            value={props?.value}
            defaultValue={props?.defaultValue}
            disabled={props?.disabled}
        />
    )
}

export interface FieldProps extends InputControlProps {
    hasError: boolean;
    hasIcon: boolean;
}

export const Field = (props: FieldProps) => {
    const randomId = props?.randomId ?? generateRandomID();

    return (
        <ControlWrapper label={props.label} subLabel={props.subLabel} testId={props.testId} id={randomId}>
            <div className={classNames("field-wrapper", {"error" : props.hasError})}>
                <InputControl {...props} randomId={randomId} />
                {props.hasIcon && props.hasError && <Icon type={"error"}/>}
            </div>
        </ControlWrapper>
    )
}